<template>
  <div id="offlinePaymentPage">
    <NavBar class="overflow-y-hidden"/>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 mx-auto">
        <v-main class="overflow-hidden ">
          <div class="has-footer-payments  pt-0">
            <div class="container-fluid">
              <div v-if="bannerLoading" class="row align-items-center ">
                <div class="col-12 text-center pb-1">
                  <v-skeleton-loader
                      class="mx-auto border"
                      type="image"
                      height="150"
                      width="100%"
                  ></v-skeleton-loader>
                </div>
                <div class="col-6 pt-0 pl-1">
                  <v-skeleton-loader
                      class="mx-auto border"
                      type="image"
                      width="100%"
                      height="150"></v-skeleton-loader>
                </div>
                <div class="col-6 pt-0 pr-1">
                  <v-skeleton-loader
                      class="mx-auto border"
                      type="image"  width="100%"
                      height="150"></v-skeleton-loader>
                </div>
              </div>
              <div v-else-if="banners.length >0" class="row">
                <div class="col-12 p-1 ">
                  <v-carousel
                      :continuous="false"
                      :cycle="true"
                      :show-arrows="false"
                      class="carousel-dots banner-carousel rounded-11px"
                      dark
                      delimiter-icon="fa-solid fa-circle-small white--text"
                      height="auto"
                      hide-delimiter-background>
                    <v-carousel-item
                        v-for="(slide, i) in banners"
                        :key="i">

                      <v-img :src="$replaceHttps(slide.FileUrl)" class="col-12">
                      </v-img>

                    </v-carousel-item>
                  </v-carousel>
                </div>
                <div v-if="!bannerLoading" class="col-12 pt-0">
                  <div class="row">
                    <div class="col-6  p-1 pt-md-2">
                      <v-img :height="$vuetify.breakpoint.xs ? 150 : 150" :src="$replaceHttps(bannerRight)"
                             class="rounded-lg"></v-img>
                    </div>
                    <div class="col-6  p-1">
                      <v-img :height="$vuetify.breakpoint.xs ? 150 : 150" :src="$replaceHttps(bannerLeft)"
                             class="rounded-lg"></v-img>
                    </div>
                  </div>
                </div>

              </div>
              <ProductsCarousel :dataLoading="specialOffersLoading" :isOnline="'false'"
                                :products="specialOffersProducts" :title="'پیشنهاد های شگفت انگیز'" :type="'پیشنهاد_شگفت_انگیز'"/>
              <ProductsOrStoreCategories :categories="storeCategories" :data-loading="storeCategoriesLoading"
                                         :isOnline="'false'" :title="'دسته بندی فروشگاه ها'"/>
              <Stores :data-loading="latestStoresLoading" :isOnline="'false'" :stores="latestStores"
                      :title="'جدیدترین فروشگاه ها'" :type="'2'"/>
              <ProductsCarousel :dataLoading="dayOffersLoading" :isOnline="'false'" :products="dayOffers"
                                :title="'روزانه های پرتخفیف'" :type="'پیشنهاد_روز'"/>
              <div class="row">
                <GridTemplate :data-loading="latestProductsLoading" :isOnline="'false'" :items="latestProducts"
                              :title="'جدیدترین محصولات'" :type="'جدیدترین_ها'" class="col-12 "/>

              </div>
              <div>
                <div class="row">
                  <h1 class="col-8 primary-text"># ترندهای روز</h1>
                  <div  class="col-4 text-left ">
                    <span class="primary-text ml-2 pointer">MORE</span>
                    <i class="fa-solid fa-arrow-left fa-lg pointer"></i>
                  </div>

                </div>
                <div v-if="trendsOfDayLoading" class="row align-items-center ">
                  <div v-for="(i) in 9" :key="i" class="col-4 d-block p-2">
                    <v-skeleton-loader
                        class="mx-auto border"
                        type="image"></v-skeleton-loader>
                  </div>
                </div>
                <div v-else-if="posts.length > 0 && posts !== undefined" class="row">

                    <router-link v-for="(item,i) in posts" :key="i" :to="{name:'TrendDetail',query:{VendorSocialNetworkID:item.VendorSocialNetworkID}}"
                                 class="p-2 d-block col-4">
                      <v-img v-if="item.FileCoverUrl !== null"  :src="$replaceHttps(item.FileCoverUrl)" class=" rounded-11px" aspect-ratio="1">
                        <div class="p-2">
                          <div v-if="item.TypeStrucGallery ===2"><i class="fa-solid fa-play white--text fa-lg shadow-lg"></i></div>
                          <div v-if="item.TypeStrucGallery ===1"><i class="fa-solid fa-images white--text fa-lg shadow"></i></div>
                        </div>
                      </v-img>
                      <v-img v-else-if="item.TypeStrucGallery===1" :src="$replaceHttps(item.FileUrl)" class=" rounded-11px" aspect-ratio="1">
                        <div class="p-2">
                          <div v-if="item.TypeStrucGallery ===2"><i class="fa-solid fa-play white--text fa-lg shadow-lg"></i></div>
                          <div v-if="item.TypeStrucGallery ===1"><i class="fa-solid fa-images white--text fa-lg shadow"></i></div>
                        </div>
                      </v-img>
                    </router-link>
                </div>
              </div>
              <StoresTemplate :data-loading="firstStoreLoading" :items="firstStores" :title="firstStoreTitle"/>
              <router-link to="LoginRegister" class="row  px-1 my-2 d-flex">
                <div class="col-6 p-3 bg-white rounded-r-lg">
                  <i class="fa-solid fa-bag-shopping font16px pointer"></i>
                  <span class="mr-2 font16px pointer">فروشگاه بسازید</span>
                </div>
                <div class="col-6 p-3 bg-white rounded-l-lg text-left">
                  <span class="font16px pointer"><i class="fa-solid fa-user-plus font16px"></i> خرید کنید/نقد کنید</span>
                </div>
              </router-link>
              <StoresTemplate :data-loading="secondStoreLoading" :items="secondStores" :title="secondStoreTitle"/>
              <div class="row my-3">
                <div class="col-12 p-1">
                  <v-carousel
                      :continuous="false"
                      :cycle="true"
                      :show-arrows="false"
                      class="banner-carousel carousel-dots rounded-11px"
                      dark
                      delimiter-icon="fa-solid fa-circle-small white--text"
                      height="auto"
                      hide-delimiter-background>
                    <v-carousel-item
                        v-for="(slide, i) in bottomBanners"
                        :key="i">
                      <v-img :src="(slide.FileUrl)">
                      </v-img>

                    </v-carousel-item>
                  </v-carousel>
                </div>

              </div>
              <ContentsCarousel :data-loading="dayNewsLoading" :items="dayNews" :title="'اخبار روز'" :type="1" :isOnline="false"/>
              <articles :data-loading="articlesLoading" :items="articles" :title="'مقاله'" :isOnline="false"/>
              <ContentsCarousel :data-loading="reviewsLoading" :items="reviews" :title="'نقد و بررسی'" :type="2" :isOnline="false"/>
              <h1 class="col-8 primary-text">فروشگاه ها در سراسر ایران</h1>
              <PaymentsHomesMap :markers="markers"/>

            </div>
            <PaymentsFooter :current-page="'home'" :is-in-online-payment="'false'"/>
          </div>
        </v-main>
      </div>
    </div>

    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
  </div>

</template>

<script>
import ProductsCarousel from "@/components/ProductsCarousel";
import ProductsOrStoreCategories from "@/components/ProductsOrStoreCategories";
import Stores from "@/components/Stores";
import GridTemplate from "@/components/GridTemplate";
import StoresTemplate from "@/components/StoresTemplate";
import ContentsCarousel from "@/components/ContentsCarousel";
import Articles from "@/components/Articles";
import PaymentsFooter from "@/components/PaymentsFooter";
import NavBar from "@/components/NavBar";
import PaymentsHomesMap from "@/components/PaymentsHomesMap";

export default {
  name: "OfflinePaymentHome",
  metaInfo: {
    title: 'ایوان خانه- OfflinePayment',
  },
  components: {
    PaymentsHomesMap,
    NavBar,
    PaymentsFooter,
    Articles,
    ContentsCarousel, StoresTemplate, GridTemplate, Stores, ProductsOrStoreCategories, ProductsCarousel
  },
  data: () => ({
    banners: [],
    bannerLoading: true,
    specialOffersProducts: [],
    specialOffersLoading: true,
    storeCategories: [],
    storeCategoriesLoading: true,
    latestStores: [],
    latestStoresLoading: true,
    dayOffers: [],
    dayOffersLoading: true,
    latestProducts: [],
    latestProductsLoading: true,
    trendsOfDay: [],
    trendsOfDayLoading: true,
    firstStores: [],
    firstStoreLoading: true,
    secondStores: [],
    secondStoreLoading: true,
    dayNews: [],
    dayNewsLoading: true,
    articles: [],
    articlesLoading: true,
    reviews: [],
    reviewsLoading: true,
    showLoaderDialog: false,
    bannerRight: null,
    bannerLeft: null,
    bannerLeftLink: null,
    bannerRightLink: null,
    store1: null,
    store2: null,
    firstStoreTitle: null,
    secondStoreTitle: null,
    bottomBanners: [],
    markers: [],
    posts: [],
  }),
  mounted() {
    this.getData()
    this.getStoresForMap()
    this.getPosts()
  },
  methods: {
    getData() {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + 'SearchEngine/ShoppingOfflineCenter', requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let banners = json.BanerViewModel.filter(x => x.IsActive === true)
            this.banners = banners.filter(x => x.TypeBaner === 7);
            this.bannerLoading = false
            let banner8Json = banners.filter(x => x.TypeBaner === 8);
            this.bannerRight = banner8Json[0].FileUrl;
            this.bannerRightLink = banner8Json[0].Link;
            let banner9Json = banners.filter(x => x.TypeBaner === 9);
            this.bannerLeft = banner9Json[0].FileUrl;
            this.bannerLeftLink = banner9Json[0].Link;
            this.storeCategories = json.ShoppingCategoryViewModel.filter(x => x.IsActive === true);
            this.storeCategoriesLoading = false;
            this.latestStores = json.VendorViewModel;
            this.latestStoresLoading = false;
            let stores = json.ShoppingCategoryViewModel.filter(x => x.IsShowCenterPage === true && x.IsActive === true);
            this.store1 = stores[0];
            this.initFirstStores();
            this.store2 = stores[1];
            this.initSecondStores();
            this.bottomBanners = banners.filter(x => x.TypeBaner === 10);
            let extraExtension = json.ExtraExtensionViewModel.filter(x => x.TypeExtraExtension === 2)
            this.dayNews = extraExtension.filter(x => x.TypeDefineExtraExtension === 1)
            this.dayNewsLoading = false;

            this.articles = extraExtension.filter(x => x.TypeDefineExtraExtension === 2)
            this.articlesLoading = false;


            this.reviews = extraExtension.filter(x => x.TypeDefineExtraExtension === 3)
            this.reviewsLoading = false;


          })
          .catch(error => console.log('error', error));

      this.getSpecialOffers()
      this.initDayOffersProducts()
      this.initLatestProducts()






    },
    getPosts() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("pageIndex", "1");
      urlencoded.append("pageSize", "9");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.posts = (JSON.parse(result).list).filter(x => x.IsActive === true)
            this.trendsOfDayLoading = false;
            this.postLoading = false
          })
          .catch(error => console.log('error', error));
    },
    getSpecialOffers() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("TypeVendorProduct", "پیشنهاد_شگفت_انگیز");
      urlencoded.append("IsOnlineVendor", "false");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };


      fetch(this.$baseUrl + "SearchEngine/_ListProduct", requestOptions)
          .then(response => response.text())
          .then(result => {
            let products = JSON.parse(result);
            for (let i = 0; i < products.length; i++) {
              products[i].tip = products[i].VendorProductTipViewModels[0]

              let voteArr = products[i].VoteViewModel

              let num = voteArr.length
              let sumVote = 0
              for (let j = 0; j < voteArr.length; j++) {
                sumVote += voteArr[j].Rate
              }
              let avg = sumVote / num;
              if (avg > 0) {
                products[i].avgVote = sumVote / num
              } else {
                products[i].avgVote = 0
              }
            }

            this.specialOffersProducts = products
            this.specialOffersLoading = false;
          })
          .catch(error => console.log('error', error));
    },
    initDayOffersProducts() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("TypeVendorProduct", "پیشنهاد_روز");
      urlencoded.append("IsOnlineVendor", "false");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchEngine/_ListProduct", requestOptions)
          .then(response => response.text())
          .then(result => {
            let products = JSON.parse(result);
            for (let i = 0; i < products.length; i++) {
              products[i].tip = products[i].VendorProductTipViewModels[0]

              let voteArr = products[i].VoteViewModel

              let num = voteArr.length
              let sumVote = 0
              for (let j = 0; j < voteArr.length; j++) {
                sumVote += voteArr[j].Rate
              }
              let avg = sumVote / num;
              if (avg > 0) {
                products[i].avgVote = sumVote / num
              } else {
                products[i].avgVote = 0
              }
            }
            this.dayOffers = products;
            this.dayOffersLoading = false;


          }).catch(error => console.log('error', error));
    },
    initLatestProducts() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("TypeSearchEngineSort", "جدیدترین_ها");
      urlencoded.append("IsOnlineVendor", "false");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };


      fetch(this.$baseUrl + "SearchEngine/_ListProduct", requestOptions)
          .then(response => response.text())
          .then(result => {
            let products = JSON.parse(result);
            for (let i = 0; i < products.length; i++) {
              products[i].tip = products[i].VendorProductTipViewModels[0]

              let voteArr = products[i].VoteViewModel

              let num = voteArr.length
              let sumVote = 0
              for (let j = 0; j < voteArr.length; j++) {
                sumVote += voteArr[j].Rate
              }
              let avg = sumVote / num;
              if (avg > 0) {
                products[i].avgVote = sumVote / num
              } else {
                products[i].avgVote = 0
              }
            }
            this.latestProducts = products;
            this.latestProductsLoading = false;


          }).catch(error => console.log('error', error));
    },
    initFirstStores() {
      let stores = this.latestStores
      let vip1 = this.store1;

      let temp = stores.filter(x => x.ShoppingCategoryID === vip1.ShoppingCategoryID);
      this.firstStores = temp;
      this.firstStoreLoading = false;
      this.firstStoreTitle = temp[0].ShoppingCategoryName;
    },
    initSecondStores() {
      let stores = this.latestStores
      let vip2 = this.store2;

      let temp = stores.filter(x => x.ShoppingCategoryID === vip2.ShoppingCategoryID);
      this.secondStores = temp;
      this.secondStoreLoading = false;
      this.secondStoreTitle = temp[0].ShoppingCategoryName;
    },
    getStoresForMap() {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + 'SearchEngine/ShoppingOfflineCenter', requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result);
            let vendors = json.VendorViewModel
            let places = []
            for (let i = 0; i < vendors.length; i++) {
              places.push({
                position: {lat: vendors[i].Latitude, lng: vendors[i].Longitude},
                vendorID: vendors[i].VendorID,
                name: vendors[i].Name,
                description: vendors[i].Description,
                date: vendors[i].ModifiedDate
              })
            }
            this.markers = places
          })
          .catch(error => console.log('error', error));
    },
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
  }
}
</script>

<style scoped>

</style>
